import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { getCodeColor } from "../components";


export const GeneratePdfAllOrdenVentas = ({ saleData, themeColor, convertPrice = (() => { }) }) => {
	const themeConverted = getCodeColor(themeColor);

	const styles = StyleSheet.create({
		page: {
			flexDirection: "column",
			padding: 10,
			fontSize: 10,
			fontFamily: "Helvetica",
			position: "relative",
			bottom: "30",
		},

		// Encabezado principal
		headerContainer: {
			flexDirection: "row",
			alignContent: "center",
			paddingBottom: 10,
		},
		headerLeft: {
			flexDirection: "column",
			width: "40%",
			lineHeight: 1.2,
			fontSize: 7,
		},
		logo: {
			width: 150,
			height: 100,
		},
		titleBig: {
			fontFamily: "Helvetica-Bold",
			fontSize: 19,
			letterSpacing: 1,
			margin: 0,
			paddingLeft: 35,
			position: "relative",
			top: "15",
			right: "40",
		},
		titleNumber: {
			fontSize: 18,
			color: "#ff3d3d",
			fontWeight: "bold",
			paddingLeft: 70,
			letterSpacing: 2,
			fontFamily: "Helvetica-Bold",
			position: "relative",
			left: 20,
		},

		// Sub-encabezado
		subHeaderContainer: {
			flexDirection: "row",
			justifyContent: "space-between",
			paddingRight: "10",
			alignItems: "center",
			position: "relative",
			bottom: 5,
			fontSize: 9,
		},

		//tabla
		tableContainer: {
			width: "100%",
			marginVertical: 10,
			position: "relative",
			bottom: 10,
		},
		tableHeader: {
			flexDirection: "row",
			backgroundColor: themeConverted,
			color: "#fff",
		},
		tableHeaderCell: {
			padding: 5,
			fontWeight: "bold",
			textAlign: "center",
			fontSize: 8,
		},
		tableRow: {
			flexDirection: "row",
		},
		tableCell: {
			padding: 5,
			textAlign: "center",
			fontSize: 8,
		},
		tableCellCode: { flex: 1.2 },
		tableCellDescription: { flex: 3, textAlign: "left" },
		tableCellQuantity: { flex: 0.8 },
		tableCellPurchase: { flex: 1.2 },
		tableCellSale: { flex: 1.2 },
		tableCellDiscount: { flex: 1 },
		tableCellTotal: { flex: 1.2 },

		tableRowTotal: {
			flexDirection: "row",
			backgroundColor: themeConverted,
			color: "#fff",
			fontWeight: "bold",
		},
		tableCellNoBorder: {
			border: "none",
			padding: 5,
			flex: 1,
			textAlign: "center",
		},
		totalCell: {
			padding: 5,
			textAlign: "center",
			fontSize: 8,
			color: "#fff",
			fontWeight: "bold",
		},

		//lineas finales firma
		signatureContainer: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-around",
			marginTop: 30,
		},
		signatureLine: {
			marginBottom: 5,
		},
		signatureBox: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		pageNumbers: {
			position: "absolute",
			bottom: 20,
			right: 20,
			textAlign: "right",
		},
	});
	if (!saleData || !saleData.details) {
		return (
			<Document>
				<Page size="A4" style={styles.page}>
					<Text>Cargando datos de ventas...</Text>
				</Page>
			</Document>
		);
	}
	const totalQuantity = saleData.details.reduce((acc, item) => acc + item.qp, 0);
	const totalPurchase = saleData.details.reduce((acc, item) => acc + parseFloat(item.pPurchase) * item.qp, 0);
	const totalSale = saleData.details.reduce((acc, item) => acc + parseFloat(item.pSale) * item.qp, 0);
	const totalDiscount = saleData.details.reduce((acc, item) => acc + parseFloat(item.pDiscount) * item.qp, 0);
	const totalBenefit = totalSale - totalPurchase;
	const apiUrl = process.env.REACT_APP_API_URL;
	return (
		<Document>
			<Page size="A4" style={styles.page}>
				{/* Encabezado */}
				<View style={styles.headerContainer}>
					<View style={styles.headerLeft}>
						<View style={{ position: "relative", top: 7 }}>
							<Image
								source={`${apiUrl}${saleData.logo}`}
								src={`${apiUrl}${saleData.logo}`}
								style={styles.logo}
							/>
						</View>
						<View>
							<Text>Empresa: {saleData.cName}</Text>
							<Text>Dirección: {saleData.address}</Text>
							<View style={{ flexDirection: "row", marginTop: "2px" }}>
								<Text>NIT: {saleData.cNit} </Text>
								<Text style={{ paddingLeft: 15 }}>Tel: {saleData.phone}</Text>
							</View>
						</View>
					</View>
					<View style={{ justifyContent: "center", alignItems: "center" }}>
						<Text style={styles.titleBig}>Ventas del Dia</Text>
					</View>
				</View>

				{/* Sub-encabezado */}
				<View style={styles.subHeaderContainer}>
					<View>
						<Text>
							Cajero: {saleData.cashier_name} {/* Tel: {saleData.cashier_phone} */}
						</Text>
						<Text>Vendedor: {saleData.seller_name}</Text>
					</View>
					<View style={{ display: "flex", flexDirection: "row", gap: "5", position: "relative", bottom: 0 }}>
						<Text>Fecha: {saleData.oDate}</Text>
						<Text style={{ fontSize: 7, position: "relative", top: "1.5" }}>{saleData.oTime}</Text>
					</View>
				</View>

				{/* Tabla */}
				<View style={styles.tableContainer}>
					<View style={styles.tableHeader}>
						<Text style={[styles.tableHeaderCell, styles.tableCellCode]}>Código</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellDescription]}>Descripción</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellQuantity]}>Cant</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellPurchase]}>Costo</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellSale]}>Precio</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellDiscount]}>Descuento</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellTotal]}>Total</Text>
					</View>

					{saleData.details.map((item, index) => {
						const total = parseFloat(item.pSale) * item.qp;
						return (
							<View style={styles.tableRow} key={index}>
								<Text style={[styles.tableCell, styles.tableCellCode]}>{item.code}</Text>
								<Text style={[styles.tableCell, styles.tableCellDescription]}>{item.description}</Text>
								<Text style={[styles.tableCell, styles.tableCellQuantity]}>{item.qp}</Text>
								<Text style={[styles.tableCell, styles.tableCellPurchase]}>
									{convertPrice(item.pPurchase, null, true)}
								</Text>
								<Text style={[styles.tableCell, styles.tableCellSale]}>
									{convertPrice(item.pSale, null, true)}
								</Text>
								<Text style={[styles.tableCell, styles.tableCellDiscount]}>
									{convertPrice(item.pDiscount, null, true)}
								</Text>
								<Text style={[styles.tableCell, styles.tableCellTotal]}>{convertPrice(total, null, true)}</Text>
							</View>
						);
					})}

					<View style={styles.tableRowTotal}>
						<Text style={[styles.totalCell, { flex: 3, textAlign: "right" }]}>TOTAL</Text>
						<Text style={[styles.totalCell, styles.tableCellQuantity]}>{totalQuantity}</Text>
						<Text style={[styles.totalCell, styles.tableCellPurchase]}>{convertPrice(totalPurchase)}</Text>
						<Text style={[styles.totalCell, styles.tableCellSale]}>{convertPrice(totalSale)}</Text>
						<Text style={[styles.totalCell, styles.tableCellDiscount]}>{convertPrice(totalDiscount)}</Text>
						<Text style={[styles.totalCell, styles.tableCellTotal]}>{convertPrice(totalSale)}</Text>
					</View>

					<View style={{ marginTop: 10 }}>
						<Text style={{ fontSize: 9 }}>Beneficio total: {convertPrice(totalBenefit)}</Text>
					</View>
				</View>

				<View style={styles.signatureContainer}>
					<View style={styles.signatureBox}>
						<Text style={styles.signatureLine}>___________________________</Text>
						<Text>{saleData.cashier_name}</Text>
						<Text>Cajero</Text>
					</View>
					<View style={styles.signatureBox}>
						<Text style={styles.signatureLine}>___________________________</Text>
						<Text>{saleData.manager_name}</Text>
						<Text>Gerente General</Text>
					</View>
				</View>
				<Text
					style={styles.pageNumbers}
					render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
					fixed
				/>
			</Page>
		</Document>
	);
};
